<template>
  <v-card flat class="update ma-0 pa-0 pa-5">
    <v-row class="ma-0 pa-0 pb-5 vetalfa-row" align="center" justify="center">
      <v-col cols="12" class="ma-0 pa-0 pb-5">
        <v-row align="center" justify="center" class="ma-0 pa-0">
          <v-img
            position="center"
            class="ma-0 pa-0"
            :max-height="120"
            centered
            contain
            :max-width="184"
            :lazy-src="logo"
            :src="logo"
          ></v-img>
        </v-row>
        <v-row align="center" justify="center" class="ma-0 pa-0">
          <p class="text-center mt-5 ma-0 pa-0 px-2 update-subtitle">
            {{ labels.SLOGAN }}
          </p>
        </v-row>
        <v-row align="center" justify="center" class="ma-0 pa-0 pt-5 mt-5">
          <v-progress-linear
            color="white"
            indeterminate
            rounded
            height="2"
            class="update-progress"
          ></v-progress-linear>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<style>
.update-subtitle {
  color: #ffffff;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 24px;
}
.update {
  height: 100%;
  width: 100%;
  overflow: hidden !important;
  background: #193153 !important;
  border-radius: 0px !important;
}
.update-progress {
  max-width: 200px;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import images from "@/constants/images.js";
import labels from "@/constants/labels.js";
export default {
  name: "Update",
  components: {},
  computed: {
    ...mapGetters("general", ["user"]),
  },
  data() {
    return {
      logo: images.LOGO_UPDATE,
      labels,
    };
  },
  methods: {
    ...mapActions("general", ["updateApp"]),
  },
  mounted: async function () {
    await this.updateApp();
  },
};
</script>